module.exports = __webpack_public_path__ + "static/media/free-otp-code.96bb2b4c.svg";